export default __webpack_public_path__ + "static/media/addCategoryBtn.ba7100a9.svg";